document.addEventListener('DOMContentLoaded', function () {
  var selectors = '[data-open-offers-drawer], a[href$="#promo"]';
  var triggers = document.querySelectorAll(selectors);

  if (!triggers.length) {
    return;
  }

  function openDrawer(event) {
    event.preventDefault();

    if (window.eventBus && typeof window.eventBus.emit === 'function') {
      window.eventBus.emit('open:offers:drawer');
    }
  }

  triggers.forEach(function (el) {
    el.addEventListener('click', openDrawer);
  });

  if (window.location.hash === '#promo') {
    setTimeout(function() {
      if (window.eventBus && typeof window.eventBus.emit === 'function') {
        window.eventBus.emit('open:offers:drawer');
      }
    }, 1500);
  }
});